import React from 'react';
import { List } from 'immutable';
import NodeLandingPageFull from './Full';
import NodeLandingPageCampaign from './Campaign';


const NodeLandingPage = (props) => {
  const { viewMode, entity } = props;
  if (entity.getIn(['field_campaign'], List()).size > 0) {
    return <NodeLandingPageCampaign {...props} />;
  }

  switch (viewMode) {

    default:
      return <NodeLandingPageFull {...props} />;
  }
};

export default NodeLandingPage;
